import clsx from 'clsx';
import { h } from 'preact';

const BeveledIcon = ({ variant, side = 'left' }) => {
  const variantClasses = {
    'primary-dark-stroke':
      'fill-transparent text-spd-grey-200 group-hover:text-black group-disabled:text-spd-disabled group-disabled:fill-transparent group-hover:fill-black/20',
    'primary-light-stroke':
      'fill-transparent text-white group-disabled:fill-black group-hover:fill-white/20 group-disabled:text-spd-grey-400',
    'primary-dark-fill':
      'group-hover:fill-black/20 group-disabled:fill-spd-disabled text-black group-disabled:text-spd-disabled',
    'primary-light-fill':
      'text-white fill-white group-hover:fill-white/20 group-disabled:fill-black group-focus:fill-black',
  };
  return (
    <svg
      viewBox="0 0 19 37"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      class={clsx(
        'absolute top-0 h-full w-auto transition-colors group-focus:text-spd-blue',
        {
          'left-0 -translate-x-[calc(100%-0.5px)]': side === 'left',
          'right-0 translate-x-[calc(100%-0.5px)] rotate-180': side === 'right',
        },
        variantClasses[variant],
      )}
    >
      <path
        d="M18.5 36.5H16.5H14.5H9.5L0.5 27.5V17.5L16.5 0.5H18.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linejoin="bevel"
        vector-effect="non-scaling-stroke"
      />
    </svg>
  );
};

export default BeveledIcon;
